import ScreenNav from '../components/ScreenNav';
import SkillsSection from '../components/SkillsSection';

export default function SkillsScreen() {
  return (
    <>
      <ScreenNav />
      <SkillsSection />
    </>
  );
}
